// import React, { useEffect, useState } from 'react';
// import { CustomTextInput } from '.';

// import Calendar from 'react-calendar';

// import "react-calendar/dist/Calendar.css";
// import { Icon, OverLay } from '../Other';

// import style from "../../Style/Components/input.module.scss";


// const CustomCalendar = (props) => {

//     const [value, setValue] = useState(null);
//     const [toggle, setToggle] = useState(false);

//     useEffect(() => {
//         if (props.value) {
//             setValue(props.value);
//         }
//     }, [props.value]);


//     console.log("value", value, "props.value", props.value);


//     const handleDateSelect = (date) => {
//         setValue(date);
//         setToggle(false);
//         props.onSelect(date);
//     };


//     const formatDate = (isoDate) => {
//         const date = new Date(isoDate);
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     };

//     return (
//         <div className=''>
//             {/* <OverLay isOpen={toggle} onClose={() => setToggle(prev => !prev)} /> */}

//             <div className='position-relative'>
//                 <div className='position-relative'>
//                     <div onClick={() => setToggle(prev => !prev)}>
//                         <CustomTextInput label={props.label}
//                             type="text"
//                             value={value !== null ? formatDate(value) : ""}
//                             className="cursor-pointer"
//                             placeholder="dd-mm-yyyy"
//                             required={props.required}
//                             handleChange={(e) => setValue(e)} />
//                     </div>


//                     <Icon icon={value === null ? "calendar" : "close"}
//                         size={20}
//                         className={`${value === null ? "" : "cursor-pointer"} position-absolute bottom-14px right-16px  `}
//                         onClick={() => {
//                             props.onClear();
//                             setValue(null);
//                         }} />
//                 </div>


//                 {toggle && (
//                     <>
//                         <div className='position-absolute top-80px start-0'>
//                             <Calendar
//                                 value={value}
//                                 minDate={props.minDate}
//                                 maxDate={props.maxDate}
//                                 onChange={handleDateSelect}
//                             />
//                         </div>
//                     </>
//                 )}

//             </div>
//             {props.error &&
//                 <p className={style.e_error_message}>
//                     {props.error}
//                 </p>
//             }
//         </div>
//     )
// }

// export default CustomCalendar;


import React, { useEffect, useState } from 'react';
import { CustomTextInput } from '.';
import Calendar from 'react-calendar';
import "react-calendar/dist/Calendar.css";
import { Icon } from '../Other';
import style from "../../Style/Components/input.module.scss";

const CustomCalendar = (props) => {
    const [value, setValue] = useState(null);         // Actual Date object
    const [toggle, setToggle] = useState(false);      // Calendar popup toggle
    const [inputValue, setInputValue] = useState(""); // Input string

    // Initialize with prop value
    useEffect(() => {
        if (props.value) {
            const dateObj = new Date(props.value);
            setValue(dateObj);
            setInputValue(formatDate(dateObj));
        } else {
            setValue(null);
            setInputValue("");
        }
    }, [props.value]);

    console.log("value", value);


    // Format Date object to dd-mm-yyyy
    const formatDate = (date) => {
        if (!date || isNaN(date)) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Parse string dd-mm-yyyy into Date object
    const parseDate = (str) => {
        const parts = str.split("-");
        if (parts.length !== 3) return null;
        const [day, month, year] = parts.map(Number);
        const parsed = new Date(year, month - 1, day);
        return (
            parsed &&
            parsed.getDate() === day &&
            parsed.getMonth() === month - 1 &&
            parsed.getFullYear() === year
        )
            ? parsed
            : null;
    };

    // Handle manual input with auto-formatting
    const handleInputChange = (val, e) => {

        // Detect backspace/delete in a cross-browser way
        const inputType = e.nativeEvent.inputType; // modern browsers
        const keyCode = e.nativeEvent.keyCode || e.nativeEvent.which; // fallback

        const isBackspace = inputType === 'deleteContentBackward' || keyCode === 8;
        const isDelete = inputType === 'deleteContentForward' || keyCode === 46;

        // If user is deleting, do nothing (let deletion happen naturally)
        if (isBackspace || isDelete) {
            setInputValue(null); // or partial value if needed
            return;
        }


        // Keep only digits always
        const digits = val.replace(/\D/g, "");

        // Build format USING ONLY RAW DIGITS
        let formatted = "";
        if (digits.length > 0) {
            formatted = digits.substring(0, 2); // dd
        }
        if (digits.length >= 2) {
            formatted += "-" + digits.substring(2, 4); // mm
        }
        if (digits.length >= 4) {
            formatted += "-" + digits.substring(4, 8); // yyyy
        }

        setInputValue(formatted);

        // Parse date when 8 digits entered
        if (digits.length === 8) {
            const day = Number(digits.slice(0, 2));
            const month = Number(digits.slice(2, 4));
            const year = Number(digits.slice(4, 8));
            const parsed = new Date(year, month - 1, day);

            if (
                parsed &&
                parsed.getDate() === day &&
                parsed.getMonth() === month - 1 &&
                parsed.getFullYear() === year
            ) {
                setValue(parsed);
                props.onSelect?.(parsed);
                setToggle(false);
            }
        }
    };



    // Called when selecting date from calendar
    const handleDateSelect = (date) => {
        setValue(date);
        const formatted = formatDate(date);
        setInputValue(formatted);
        setToggle(false);
        if (props.onSelect) props.onSelect(date);
    };

    const handleClear = () => {
        setValue(null);
        setInputValue("");
        if (props.onClear) props.onClear();
    };

    const handleEnterKey = () => {
        const parsed = parseDate(inputValue);
        if (parsed) {
            setValue(parsed);
            setToggle(false); // close calendar
            if (props.onSelect) props.onSelect(parsed);
        }
    };

    return (
        <div>
            {toggle && (
                <div style={{ position: "absolute", width: "100%", height: "100%", backgroundColor: "transparent" }}
                    className="top-0 start-0 z-2"
                    onClick={() => setToggle(false)}
                ></div>
            )}
            <div className="position-relative">
                <CustomTextInput
                    label={props.label}
                    value={inputValue}
                    placeholder="dd-mm-yyyy"
                    required={props.required}
                    handleChange={handleInputChange} // Accepts string input
                    onClick={() => setToggle(true)}
                    onKeyPress={handleEnterKey}
                />

                <Icon
                    icon={value === null ? "calendar" : "close"}
                    size={20}
                    className={`${value === null ? "" : "cursor-pointer"} position-absolute bottom-14px right-16px`}
                    onClick={handleClear}
                />

                {toggle && (
                    <>
                        {/* Calendar popup */}
                        <div className="position-absolute top-80px start-0 end-0 m-auto z-3 bg-white shadow-lg">
                            <Calendar
                                value={value}
                                minDate={props.minDate}
                                maxDate={props.maxDate}
                                onChange={handleDateSelect}
                            />
                        </div>
                    </>
                )}
            </div>

            {props.error && (
                <p className={style.e_error_message}>{props.error}</p>
            )}
        </div>
    );
};

export default CustomCalendar;
